<template>
    <el-dialog
            :visible="isVisible"
            @close="hide"
            :title="title"
            :destroy-on-close="true"
    >
        <loading v-if="!isInitialized"></loading>
        <whitelist-ip-form v-if="isInitialized" v-bind="formData" @stored="onStored"></whitelist-ip-form>
    </el-dialog>
</template>

<script>
  import BaseDialogFormWrapper from '../../components/dialog-form-wrapper';
  import WhitelistIpForm from '../../components/whitelist-ip/form';
  import Loading from '../../components/loading';
  import eventBus from '../../event-bus';

  export default {
    extends: BaseDialogFormWrapper,

    components: {
      Loading,
      WhitelistIpForm,
    },

    computed: {
      /**
       * @return {boolean}
       */
      modelExists() {
        return _.has(this.formData, 'model.id');
      },

      /**
       * @return {string}
       */
      title() {
        if (!this.isInitialized) {
          return 'Loading ...';
        } else if (this.modelExists) {
          return 'Edit Whitelist Ip';
        }

        return 'Create Whitelist Ip';
      },
    },

    methods: {
      /**
       * @param {string|undefined} message
       */
      onStored({message}) {
        _.isString(message) && this.$message.success(message);
        this.hide();
        eventBus.$emit('refresh-whitelist-ip-table');
      },
    },

    created() {
      eventBus.$on('show-whitelist-ip-form-dialog', this.show);
    },

    beforeDestroy() {
      eventBus.$off('show-whitelist-ip-form-dialog', this.show);
    }
  }
</script>
